var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

export default invariant;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/tiny-invariant/dist/tiny-invariant.esm.js
// module id = J/HR
// module chunks = 0